import React from 'react';
import { Helmet } from 'react-helmet';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/home/Home';

export default function App() {
  return (
    <main>
      <Helmet>
        <title>Arthanova Global | Technology Delivery</title>
        <meta
          name="description"
          content="Arthanova Global Private Limited is an India-based technology delivery partner supporting software development, AI, automation and digital product projects."
        />
      </Helmet>

      <Navbar />
      <Home />
      <Footer />
    </main>
  );
}